module.exports = __webpack_public_path__ + "files/3c5e700bc87681bf76b06eac7525de91.png";